import { Dispatch } from 'redux';
import { getApis } from '../../library/Apis';
import api from '../../services/api';
import { toRequest } from '../../utils/RequestUtils';

export const RESETED_LOGRADOURO = 'RESETED_LOGRADOURO';
export const LOADING_ESTADOS_ACTION = 'LOADING_ESTADOS_ACTION';
export const LOADED_ESTADOS_ACTION = 'LOADED_ESTADOS_ACTION';
export const LOADED_CENTRAIS_ACTION = 'LOADED_CENTRAIS_ACTION';
export const LOADED_COOPS_CENTRAL_ACTION = 'LOADED_COOPS_CENTRAL_ACTION';
export const LOADING_CIDADES_ACTION = 'LOADING_CIDADES_ACTION';
export const LOADED_CIDADES_ACTION = 'LOADED_CIDADES_ACTION';
export const LOADING_COOPERATIVAS_ACTION = 'LOADING_COOPERATIVAS_ACTION';
export const LOADED_COOPERATIVAS_ACTION = 'LOADED_COOPERATIVAS_ACTION';
export const LOADING_ALL_COOPERATIVAS_ACTION =
  'LOADING_ALL_COOPERATIVAS_ACTION';
export const LOADED_ALL_COOPERATIVAS_ACTION = 'LOADED_ALL_COOPERATIVAS_ACTION';
export const LOADING_ALL_CENTRAIS_ACTION = 'LOADING_ALL_CENTRAIS_ACTION';
export const LOADING_COOPS_CENTRAL_ACTION = 'LOADING_COOPS_CENTRAL_ACTION';
export const LOADING_ALL_ESTADOS_BY_COOPS_ACTION =
  'LOADING_ALL_ESTADOS_BY_COOPS_ACTION';
export const LOADED_ALL_ESTADOS_BY_COOPS_ACTION =
  'LOADED_ALL_ESTADOS_BY_COOPS_ACTION';
export const LOADING_COOPS_CENTRAL_STATE_ACTION =
  'LOADING_COOPS_CENTRAL_STATE_ACTION';
export const LOADED_COOPS_CENTRAL_STATE_ACTION =
  'LOADING_COOPS_CENTRAL_STATE_ACTION';
export const LOADING_ALL_ESTADOS_AND_COOPS_BY_IDCENTRAL =
  'LOADING_ALL_ESTADOS_AND_COOPS_BY_IDCENTRAL';
export const LOADED_ALL_ESTADOS_AND_COOPS_BY_IDCENTRAL =
  'LOADED_ALL_ESTADOS_AND_COOPS_BY_IDCENTRAL';
export const LOADED_ALL_CIDADES_BY_LIST_ESTADO_ID =
  'LOADED_ALL_CIDADES_BY_LIST_ESTADO_ID';
export const LOADING_ALL_CIDADES_BY_LIST_ESTADO_ID =
  'LOADING_ALL_CIDADES_BY_LIST_ESTADO_ID';

const getEndpoint = () => {
  return getApis().apis.backofficeProjetos + 'v1/logradouro/';
};

export const resetLogradouroReducer = () => ({
  type: RESETED_LOGRADOURO,
  payload: null,
});

export const loadEstados = (
  callbackSuccess?: () => void,
  callbackError?: (error: void) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_ESTADOS_ACTION,
      payload: true,
    });
    toRequest(api.get, [getEndpoint() + 'estados'], 'estados').then(
      (resp) => {
        dispatch({
          type: LOADED_ESTADOS_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ESTADOS_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ESTADOS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadCooperativas = (
  all?: boolean,
  codCoopsNecessarios?: string[],
  callbackSuccess?: () => void,
  callbackError?: (error: void) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_COOPERATIVAS_ACTION,
      payload: true,
    });
    const todos = typeof all === 'boolean' && all ? 'true' : 'false';
    const coopsNecessarios =
      codCoopsNecessarios &&
        typeof codCoopsNecessarios === 'object' &&
        typeof codCoopsNecessarios.length === 'number'
        ? [...codCoopsNecessarios]
        : [];
    toRequest(
      api.post,
      [getEndpoint() + 'coops/' + todos, coopsNecessarios],
      'cooperativas'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_COOPERATIVAS_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_COOPERATIVAS_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_COOPERATIVAS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadAllCooperativas = (
  callbackSuccess?: () => void,
  callbackError?: (error: void) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_ALL_COOPERATIVAS_ACTION,
      payload: true,
    });
    toRequest(api.get, [getEndpoint() + 'todasCoops'], 'cooperativas').then(
      (resp) => {
        dispatch({
          type: LOADED_ALL_COOPERATIVAS_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ALL_COOPERATIVAS_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ALL_COOPERATIVAS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadCidadesByEstadoId = (
  estadoId: number,
  estadoUf: string,
  callbackSuccess?: (data: string[]) => void,
  callbackError?: (error: void) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_CIDADES_ACTION,
      payload: true,
    });
    toRequest(api.get, [getEndpoint() + 'cidades/' + estadoId], 'cidades').then(
      (resp) => {
        dispatch({
          type: LOADED_CIDADES_ACTION,
          payload: {
            cidades: [...resp.data],
            uf: estadoUf,
          },
        });
        dispatch({
          type: LOADING_CIDADES_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp.data);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_CIDADES_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadCentrais = (
  callbackSuccess?: () => void,
  callbackError?: (error: void) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_ALL_CENTRAIS_ACTION,
      payload: true,
    });
    toRequest(api.get, [getEndpoint() + 'centrais'], 'centrais').then(
      (resp) => {
        dispatch({
          type: LOADED_CENTRAIS_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ALL_CENTRAIS_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ALL_CENTRAIS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadCoopsByIdCentral = (
  idCentral: number | null,
  callbackSuccess?: () => void,
  callbackError?: (error: void) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_COOPS_CENTRAL_ACTION,
      payload: true,
    });
    toRequest(
      api.get,
      [getEndpoint() + 'coops/idCentral/' + idCentral],
      'centrais'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_COOPS_CENTRAL_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_COOPS_CENTRAL_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_COOPS_CENTRAL_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadAllEstadosByCoops = (
  codCoopsNecessarios: number[],
  callbackSuccess?: () => void,
  callbackError?: (error: void) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_ALL_ESTADOS_BY_COOPS_ACTION,
      payload: true,
    });
    const coopsNecessarios =
      codCoopsNecessarios &&
        typeof codCoopsNecessarios === 'object' &&
        typeof codCoopsNecessarios.length === 'number'
        ? [...codCoopsNecessarios]
        : [];
    toRequest(
      api.post,
      [getEndpoint() + 'estados/coops', coopsNecessarios],
      'estados-coops'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_ALL_ESTADOS_BY_COOPS_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ALL_ESTADOS_BY_COOPS_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ALL_ESTADOS_BY_COOPS_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadAllEstadosAndCoopsByCentral = (
  idCentral: number,
  callbackSuccess?: () => void,
  callbackError?: (error: void) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_ALL_ESTADOS_AND_COOPS_BY_IDCENTRAL,
      payload: true,
    });
    toRequest(
      api.get,
      [`${getEndpoint()}estados-coops/idCentral/${idCentral}`],
      'estados-coops-by-central'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_ALL_ESTADOS_AND_COOPS_BY_IDCENTRAL,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ALL_ESTADOS_AND_COOPS_BY_IDCENTRAL,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      () => {
        dispatch({
          type: LOADING_ALL_ESTADOS_AND_COOPS_BY_IDCENTRAL,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError();
        }
      }
    );
  };
};

export const loadAllCidadesByIdEstadoList = (
  idsEstado: number[] | null,
  callbackSuccess?: () => void,
  callbackError?: (error: void) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_ALL_CIDADES_BY_LIST_ESTADO_ID,
      payload: true,
    });
    toRequest(api.post, [getEndpoint() + 'cidades', idsEstado], 'cidades').then(
      (resp) => {
        dispatch({
          type: LOADED_ALL_CIDADES_BY_LIST_ESTADO_ID,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ALL_CIDADES_BY_LIST_ESTADO_ID,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ALL_CIDADES_BY_LIST_ESTADO_ID,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};
